module.exports = __webpack_public_path__ + "src/assets/img/smoke_five.f856a710.svg";